import { defineComponent as _defineComponent } from 'vue'
import InlineSvg from "vue-inline-svg";

import FileInput from "@/components/shared/inputs/FileInput.vue";
import { IVocDetail } from "@/domain/entities/bbs";
import { IFile } from "@/domain/entities/bbs/qnaDetail.types";

import { PropType, ref } from "vue";
import Modal from "@/components/shared/modal/base/Modal.vue";


const __default__ = {
  name: "VocFileUploader",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  label: {
    type: String,
    default: "",
  },
  required: {
    type: Boolean,
    default: false,
  },
  editMode: {
    type: Boolean,
    default: false,
  },
  vocDetail: {
    type: Object as PropType<IVocDetail>,
  },
},
  emits: ["onAddedFiles", "onDeletedFiles"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;

const emit = __emit;

const emitOnAddedFiles = (addedFiles: File[], fileInputUid: string) => {
  emit("onAddedFiles", addedFiles, fileInputUid);
};

const emitOnDeletedFiles = (fileInfo: IFile, fileInputUid: string) => {
  emit("onDeletedFiles", fileInfo, fileInputUid);
};

const shouldShowFallbackTextGuideModal = ref(false);
const toggleShowFallbackTextGuideModal = (show: boolean) => {
  shouldShowFallbackTextGuideModal.value = show;
};

const getFileInfos = (index: number) => {
  const fileInfo = props.vocDetail?.files?.[index];
  return fileInfo ? [fileInfo] : [];
};

const __returned__ = { props, emit, emitOnAddedFiles, emitOnDeletedFiles, shouldShowFallbackTextGuideModal, toggleShowFallbackTextGuideModal, getFileInfos, FileInput, Modal }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})